import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Dossie } from '../models/dossie.model';
import { DossieRepository, DOSSIER_REPOSITORY } from '../repositories/dossie.repository';
import { DataLoadOrigin } from '../../../core/shared/models/data-load-options.model';

@Injectable({
  providedIn: 'root'
})
export class BuscarDossieUseCase {
  constructor(
    @Inject(DOSSIER_REPOSITORY) private readonly repository: DossieRepository
  ) {}

  execute(id: number, origin: DataLoadOrigin = 'user'): Observable<Dossie> {
    void origin;
    return this.repository.buscarDossiePorId(id);
  }
}
